module.exports = __webpack_public_path__ + "img/portfolio-03-481x325.7c1b3e38.jpg";